import { render, staticRenderFns } from "./paymentAccountDetail.vue?vue&type=template&id=2a770064&scoped=true"
import script from "./paymentAccountDetail.vue?vue&type=script&lang=js"
export * from "./paymentAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./paymentAccountDetail.vue?vue&type=style&index=0&id=2a770064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a770064",
  null
  
)

export default component.exports